import {IAuthBridge} from "@kta20-core/interfaces/auth/i-auth-bridge";
import {METHOD_NOT_IMPL} from "@kta20-core/constants";
import {UserInfo} from "@kta20-core/models/auth/user-info";
import {IUserInfoAdapter} from "@kta20-core/interfaces/auth/i-user-info-adapter";
import {IBridge} from "@kta20-core/interfaces/i-bridge";
import {IAuthService} from "@kta20-core/interfaces/auth/i-auth-service";
import {EventTarget} from "@kta20-core/core-module";


export class AuthBridge implements IAuthBridge, IBridge{

    private authService: IAuthService;

    static factory(authService:IAuthService): IBridge {
        const br = new AuthBridge();
        br.authService = authService;
        return br;
    };

    getToken(): string {
        return this.authService.getToken();
    }

    async getUserInfo(): Promise<UserInfo> {
        return await this.authService.getUserInfo();
    }

    async isUserAuthenticated(): Promise<boolean> {
        return !(await this.authService.isTokenExpired());
    }

    getUserInfoAdapter(): IUserInfoAdapter {
        return this.authService.getUserInfoAdapter();
    }

    serUserInfoAdapter(userInfoAdapter: IUserInfoAdapter) {
        this.authService.setUserInfoAdapter(userInfoAdapter);
    }

    //=============== NOT SUPPORTED IN KT1 FLOW AND INTEGRATION =====================//
    addEventListener(type: any, listener: any, options?: boolean | EventTarget.AddOptions): void {
        type;listener;options;
        throw Error(METHOD_NOT_IMPL);
    }

    removeEventListener(type: any, listener: any, options?: boolean | EventTarget.RemoveOptions): void {
        type;listener;options;
        throw Error(METHOD_NOT_IMPL);
    }

    logout() {
        throw Error(METHOD_NOT_IMPL);
    }
    //===============================================================================//

}